const DifficultyLevelColors = {
  VeryEasy: "#00DBA2",
  Easy: "#00CC2D",
  Medium: "#FFD45A",
  Hard: "#FDA420",
  VeryHard: "#EE5942",
};

export default DifficultyLevelColors;
